import Vue from "vue"
import Router from "vue-router"
import axios from "axios"

import User from "@/lib/user"

import Default from "@/containers/Default"
import About from "@/containers/About"
import Login from "@/containers/Login"
import Logout from "@/containers/Logout"
import AssessmentSection from "@/containers/assessments/AssessmentSection"
import MemberAssessments from "@/containers/assessments/MemberAssessments"
import DashboardMentee from "@/containers/dashboards/DashboardMentee"
import DashboardManager from "@/containers/dashboards/DashboardManager"
import EnneagramView from "@/containers/assessments/EnneagramView"
import EnneagramViewMentor from "@/containers/assessments/EnneagramViewMentor"
import ProDView from "@/containers/assessments/ProDView"
import ProDViewMentor from "@/containers/assessments/ProDViewMentor"
import ViaView from "@/containers/assessments/ViaView"
import ViaViewMentor from "@/containers/assessments/ViaViewMentor"
import FourMatView from "@/containers/assessments/FourMatView"
import FourMatViewMentor from "@/containers/assessments/FourMatViewMentor"
import DistributionRequestSection from "@/containers/distributions/DistributionRequestSection"
import DocumentsListMember from "@/containers/documents/DocumentsListMember"
import DocumentsListMentor from "@/containers/documents/DocumentsListMentor"
import DocumentsListManager from "@/containers/documents/DocumentsListManager"
import CoursesGridManager from "@/containers/learnings/CoursesGridManager"
import CoursesGridMentor from "@/containers/learnings/CoursesGridMentor"
import CoursesGridMember from "@/containers/learnings/CoursesGridMember"
import CourseManager from "@/containers/learnings/CourseManager"
import CourseMentor from "@/containers/learnings/CourseMentor"
import CourseMember from "@/containers/learnings/CourseMember"
import ReflectionSection from "@/containers/reflections/ReflectionSection"
import ReflectionShow from "@/containers/reflections/ReflectionShow"
import ReflectionEdit from "@/containers/reflections/ReflectionEdit"
import UserProfile from "@/containers/users/UserProfile"
import Admin from "@/containers/admin/Admin"
import SetupUser from "@/containers/SetupUser"
import ForgotPassword from "@/containers/ForgotPassword"
import MemberMessages from "@/containers/messages/MemberMessages"
import MenteeView from "@/containers/users/MenteeView"
import BadgeList from "@/containers/badges/BadgeList"
import LearningItemManager from "@/containers/learnings/LearningItemManager"
import LearningItemsManager from "@/containers/learnings/LearningItemsManager"
import LearningItemMentor from "@/containers/learnings/LearningItemMentor"
import LearningItemMember from "@/containers/learnings/LearningItemMember"
import Restricted from "@/components/Restricted"
import SystemMessageUpdate from "@/containers/messages/SystemMessageUpdate"
import ToolsAssign from "@/containers/tools/ToolsAssign"
import ToolsList from "@/containers/tools/ToolsList"
import ServerDown from "@/components/ServerDown"
import BudgetsListMentee from "@/containers/tools/budgets/BudgetsListMentee"
import BudgetsListMentor from "@/containers/tools/budgets/BudgetsListMentor"
import BudgetViewMentee from "@/containers/tools/budgets/BudgetViewMentee"
import BudgetViewMentor from "@/containers/tools/budgets/BudgetViewMentor"
import CompoundInterestMentee from "@/containers/tools/compoundInterest/CompoundInterestMentee"

Vue.use(Router)

let router = new Router({
  routes: [
    { name: "default", path: "/", component: Default },
    {
      name: "dashboardMentee",
      path: "/dashboard/mentee/:id",
      component: DashboardMentee
    },
    {
      name: "dashboardMentor",
      path: "/dashboard/mentor/:id",
      component: DashboardMentee
    },
    {
      name: "dashboardManager",
      path: "/dashboard/manager",
      component: DashboardManager
    },
    { name: "assessments", path: "/assessments", component: AssessmentSection },
    {
      name: "MemberAssessments",
      path: "/assessments/:id",
      component: MemberAssessments
    },
    {
      name: "EnneagramView",
      path: "/assessments/enneagram",
      component: EnneagramView
    },
    {
      name: "EnneagramViewMentor",
      path: "/assessments/enneagram/user/:id",
      component: EnneagramViewMentor
    },
    {
      name: "ProDView",
      path: "/assessments/prod",
      component: ProDView
    },
    {
      name: "ProDViewMentor",
      path: "/assessments/prod/user/:id",
      component: ProDViewMentor
    },
    {
      name: "ViaView",
      path: "/assessments/via",
      component: ViaView
    },
    {
      name: "ViaViewMentor",
      path: "/assessments/via/user/:id",
      component: ViaViewMentor
    },
    {
      name: "FourMatView",
      path: "/assessments/4mat",
      component: FourMatView
    },
    {
      name: "FourMatViewMentor",
      path: "/assessments/4mat/user/:id",
      component: FourMatViewMentor
    },
    {
      name: "distributions",
      path: "/distributions",
      component: DistributionRequestSection
    },
    {
      name: "BadgeList",
      path: "/badges",
      component: BadgeList
    },
    {
      name: "documentsListMember",
      path: "/documents",
      component: DocumentsListMember
    },
    {
      name: "documentsListManager",
      path: "/documents/manager",
      component: DocumentsListManager
    },
    {
      name: "documentsListMentor",
      path: "/documents/mentor/user/:id",
      component: DocumentsListMentor
    },
    {
      // member views their list of assigned courses
      name: "coursesGridMember",
      path: "/courses",
      component: CoursesGridMember
    },
    {
      // member views / updates their assigned course by course id
      name: "coursesMember",
      path: "/courses/:id",
      component: CourseMember
    },
    {
      // manager viewing all member assigned courses by member id
      // moves to mentoring mode
      // currently is reused in manager and member view
      // needs 2 routes:
      //   - shows users courses ( mode = mentoring )
      //   - shows all templates ( mode = manager )
      name: "coursesGridManager",
      path: "/manager/courses",
      component: CoursesGridManager,
      props: route => ({ userId: route.query.user_id })
    },
    {
      // manager viewing / editing a template
      // stays in manager mode paradigm
      name: "coursesManager",
      path: "/manager/courses/:id",
      component: CourseManager,
      props: route => {
        let edit = Boolean(route.query.edit)
        return { template: true, edit }
      }
    },
    {
      name: "coursesGridMentor",
      path: "/mentor/courses/user/:id",
      component: CoursesGridMentor
    },
    {
      name: "coursesMentor",
      path: "/mentor/courses/course/:id",
      component: CourseMentor
    },
    {
      name: "detailsMentorView",
      path: "/mentor/details/:id",
      component: MenteeView
    },
    { name: "about", path: "/about", component: About },
    { name: "login", path: "/login", component: Login },
    { name: "logout", path: "/logout", component: Logout },
    { name: "setup", path: "/setup/:token", component: SetupUser },
    { name: "forgotPassword", path: "/forgot", component: ForgotPassword },
    { name: "reflections", path: "/reflections", component: ReflectionSection },
    {
      name: "reflectionsView",
      path: "/reflections/:id",
      component: ReflectionShow
    },
    {
      name: "reflectionsEdit",
      path: "/reflections/:id/edit",
      component: ReflectionEdit
    },
    {
      name: "user",
      path: "/user/",
      component: UserProfile
    },
    {
      name: "userDetailsView",
      path: "/user/:id",
      component: MenteeView
    },
    {
      name: "admin",
      path: "/admin/",
      component: Admin
    },
    {
      name: "memberMessages",
      path: "/messages/:id",
      component: MemberMessages
    },
    {
      name: "LearningItemsManager",
      path: "/manager/learnings",
      component: LearningItemsManager
    },
    {
      name: "learningItemManager",
      path: "/manager/learnings/:id",
      component: LearningItemManager,
      props: route => {
        let edit = Boolean(route.query.edit)
        return { edit }
      }
    },
    {
      name: "learningItemMentor",
      path: "/mentor/learnings/:id",
      component: LearningItemMentor
    },
    {
      name: "learningItemMember",
      path: "/learnings/:id",
      component: LearningItemMember
    },
    {
      name: "systemMessageMentor",
      path: "/mentor/systemMessages/:id",
      component: SystemMessageUpdate
    },
    {
      name: "serverDown",
      path: "/unavailable",
      component: ServerDown
    },
    {
      name: "restricted",
      path: "/restricted",
      component: Restricted
    },
    {
      name: "budget",
      path: "/tools/budgets",
      component: BudgetsListMentee
    },
    {
      name: "budgetMentor",
      path: "/mentor/tools/:id/budgets",
      component: BudgetsListMentor
    },
    {
      name: "budgetView",
      path: "/tools/budgets/:budgetId",
      component: BudgetViewMentee,
      props: route => {
        let edit = Boolean(route.query.edit)
        return { edit }
      }
    },
    {
      name: "budgetViewMentor",
      path: "/mentor/tools/budgets/:budgetId",
      component: BudgetViewMentor,
      props: route => {
        let edit = false
        return { edit }
      }
    },
    {
      name: "compoundInterestView",
      path: "/tools/interest",
      component: CompoundInterestMentee
    },
    {
      name: "tools",
      path: "/tools",
      component: ToolsList
    },
    {
      name: "toolsAssign",
      path: "/tools/assign/:id",
      component: ToolsAssign
    },
    { path: "*", redirect: "/" }
  ]
})

router.beforeEach((to, from, next) => {
  if (!isRestricted(to)) {
    next()
  } else {
    next(false)
    router.push({ name: "restricted" })
  }

  if (!User.isLoggedIn() && !excludedPath(to)) {
    router.push({ name: "login" })
  }
})

function isRestricted(to) {
  if (to.path.indexOf("admin") !== -1 && !User.isPresident()) {
    return true
  }

  if (to.path.indexOf("mentor") !== -1 && !User.isManagerOrPresident()) {
    return true
  }

  if (to.path.indexOf("manager") !== -1 && !User.isManagerOrPresident()) {
    return true
  }

  return false
}

function excludedPath(to) {
  if (
    to.path == "/login" ||
    to.path == "/about" ||
    to.path == "/forgot" ||
    to.path.indexOf("setup") !== -1
  ) {
    return true
  }
  return false
}

axios.interceptors.response.use(
  response => response,
  error => {
    if (
      error.message === "Network Error" &&
      router.currentRoute.name != "serverDown"
    ) {
      router.push({ name: "serverDown" })
    }
    if (error.response) {
      //TODO: We need to do something more useful than log http errors
      if (
        error.response.status == "401" &&
        error.response.statusText.includes("Your session expired")
      ) {
        User.removeToken("")
        if (router.currentRoute.path != "/login") {
          router.push({ name: "login" })
        }
        EventBus.$emit("flash", {
          text: `ERROR:  ${error.response.status} ${error.response.statusText}`,
          type: "error",
          visible: true
        })
      }
      if (
        error.response.status == "401" &&
        error.response.data.includes("revoked token")
      ) {
        if (router.currentRoute.path != "/login") {
          router.push({ name: "logout" })
        }
      }
    }
    return Promise.reject(error)
  }
)

export default router
